export const AI = ({ props, height = 22, width = 22 }) => (
  <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.37448 16L8.44648 7.48H10.3545L13.4265 16H11.7945L11.0865 13.984H7.71448L7.00648 16H5.37448ZM8.17048 12.652H10.6305L9.40648 9.052L8.17048 12.652ZM14.333 16V7.48H15.893V16H14.333Z"
      fill="url(#paint0_linear_16097_57712)"
    />
    <path
      d="M12.5 3H4C2.89543 3 2 3.89543 2 5V18C2 19.1046 2.89543 20 4 20H18C19.1046 20 20 19.1046 20 18V9"
      stroke="url(#paint1_linear_16097_57712)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5186 0L16.8813 1.94533C16.8487 2.04636 16.7926 2.1382 16.7175 2.2133C16.6425 2.2884 16.5507 2.34461 16.4497 2.37732L14.5 3.01861L16.4453 3.65587C16.5464 3.6885 16.6382 3.74465 16.7133 3.81969C16.7884 3.89474 16.8446 3.98653 16.8773 4.08753L17.5186 6.03722L18.1559 4.0919C18.1885 3.99087 18.2446 3.89903 18.3197 3.82393C18.3947 3.74882 18.4865 3.69261 18.5875 3.6599L20.5372 3.01861L18.5919 2.38135C18.4909 2.34872 18.399 2.29257 18.3239 2.21753C18.2488 2.14249 18.1926 2.05069 18.1599 1.94969L17.5186 0Z"
      fill="url(#paint2_linear_16097_57712)"
    />
    <path
      d="M20.25 4L19.8806 5.12778C19.8616 5.18635 19.8291 5.23959 19.7856 5.28313C19.7421 5.32667 19.6889 5.35926 19.6303 5.37822L18.5 5.75L19.6278 6.11944C19.6863 6.13836 19.7396 6.17091 19.7831 6.21442C19.8267 6.25792 19.8593 6.31114 19.8782 6.36969L20.25 7.5L20.6194 6.37222C20.6384 6.31365 20.6709 6.26041 20.7144 6.21687C20.7579 6.17333 20.8111 6.14074 20.8697 6.12178L22 5.75L20.8722 5.38056C20.8137 5.36164 20.7604 5.32909 20.7169 5.28558C20.6733 5.24208 20.6407 5.18886 20.6218 5.13031L20.25 4Z"
      fill="url(#paint3_linear_16097_57712)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_16097_57712"
        x1="5.78153"
        y1="0.0808722"
        x2="17.6814"
        y2="1.21245"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B6F4FE" />
        <stop offset="0.812131" stopColor="#6C94FF" />
        <stop offset="0.961538" stopColor="#A497FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_16097_57712"
        x1="3.1723"
        y1="-1.16407"
        x2="20.8646"
        y2="1.21108"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B6F4FE" />
        <stop offset="0.812131" stopColor="#6C94FF" />
        <stop offset="0.961538" stopColor="#A497FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_16097_57712"
        x1="14.8932"
        y1="-1.47879"
        x2="20.8386"
        y2="-0.724978"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B6F4FE" />
        <stop offset="0.812131" stopColor="#6C94FF" />
        <stop offset="0.961538" stopColor="#A497FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_16097_57712"
        x1="18.7279"
        y1="3.14269"
        x2="22.1747"
        y2="3.5797"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B6F4FE" />
        <stop offset="0.812131" stopColor="#6C94FF" />
        <stop offset="0.961538" stopColor="#A497FF" />
      </linearGradient>
    </defs>
  </svg>
);
